import script from "./SellerOnboardingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerOnboardingPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerOnboardingPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__